import { WM_VIEWBOX, WM_W, WM_H, WM_PATHS } from './brandVector'

/**
 * CreepLogo — ВЕКТОРНЫЙ вордмарк "creepbrowser".
 *
 * Контуры (path) векторизованы из утверждённой картинки логотипа
 * (tools/build_brand_vec.py → brandVector.ts) — выглядит ИМЕННО как тот
 * вариант, но это чистый вектор: одинаково везде, не зависит от шрифта.
 *
 * creep — foreground, browser — muted, каретка — цвет темы (var --primary),
 * мигает как терминальный курсор.
 */
const FILL: Record<string, string> = {
  creep: 'var(--foreground)',
  browser: 'var(--muted-foreground)',
  caret: 'var(--primary)',
}

interface CreepLogoProps {
  size?: number
  animate?: boolean
  className?: string
}

export function CreepLogo({ size = 24, animate = true, className = '' }: CreepLogoProps) {
  const width = (size * WM_W) / WM_H
  return (
    <svg
      className={className}
      width={width}
      height={size}
      viewBox={WM_VIEWBOX}
      fill="none"
      role="img"
      aria-label="creepbrowser"
      style={{ display: 'block', userSelect: 'none' }}
    >
      {WM_PATHS.map((p, i) => (
        <path key={i} d={p.d} transform={`translate(${p.tx},${p.ty})`} fill={FILL[p.c]}>
          {p.c === 'caret' && animate && (
            <animate
              attributeName="opacity"
              values="1;1;0;0;1"
              keyTimes="0;0.45;0.5;0.95;1"
              dur="1.1s"
              repeatCount="indefinite"
            />
          )}
        </path>
      ))}
    </svg>
  )
}

export default CreepLogo
